import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { AircraftTypeRatingAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-aircraft-type-rating-audit-list',
  templateUrl: './aircraft-type-rating-audit-list.component.html',
  styleUrls: ['./aircraft-type-rating-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AircraftTypeRatingAuditListComponent implements OnInit {
  @Input() aircraftTypeRatingId: number;
  @Input() loading: boolean;
  @Input() aircraftTypeRatingAudits: AircraftTypeRatingAudit[];

  @Output() loadAircraftTypeRating = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAircraftTypeRating.emit(this.aircraftTypeRatingId);
  }

  onNextPage() {
    this.nextPage.emit(this.aircraftTypeRatingId);
  }
}
